<template>
  <div class="jsc-bg">
    <div class="top" style="position: sticky; z-index: 99">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">体育竞赛驾驶舱</div>
      <div class="sys-temp">
        <el-select v-model="currSeason" placeholder="请选择" @change="selectChange" style="width: 120px">
          <el-option v-for="item in seasonList" :key="item.ruleId" :label="item.year" :value="item.ruleId"> </el-option>
        </el-select>
      </div>
    </div>
    <div>
      <my-scale @changeSize="changeSize">
        <div
          :style="{
            'margin-top': 'calc(' + mySize + 'vw' + ' + 16px',
          }"
          class="d-aligncnter"
          style="width: 1920px"
        >
          <div
            class="left-box"
            id="table-content"
            style="position: relative"
            @mouseenter="stopScroll"
            @mouseleave="startScroll"
          >
            <table class="table" cellspacing="0" style="position: sticky; top: 0px; margin: 16px 0 0 16px">
              <tr class="t-head" style="font-size: 16px">
                <td class="td-1"><div>本年度竞赛活动列表</div></td>
                <td class="td-2"><div>负责人</div></td>
                <td class="td-2"><div>竞赛时间</div></td>
                <td class="td-2"><div>报名人数</div></td>
                <td class="td-2"><div>参赛人数</div></td>
              </tr>
            </table>
            <div class="left-table">
              <table class="table table-content" cellspacing="0">
                <tr
                  class="tr-line"
                  :class="{
                    'has-bg': index % 2 == 1,
                    'curr-bg': index == currIndex,
                  }"
                  style="font-size: 16px"
                  v-for="(item, index) in raceList"
                  :key="'race_' + index"
                  @click="changeCurrRace(item, index)"
                >
                  <td class="td-1 d-aligncnter d-allcenter" style="line-height: 56px">
                    <img
                      class="title-img"
                      style="margin-right: 4px; height: 56px"
                      src="@/assets/img/competition/arrow.svg"
                      v-if="index == currIndex"
                    />
                    <div>{{ item.infoName }}</div>
                  </td>
                  <td class="td-2">{{ item.charge }}</td>
                  <td class="td-2">{{ item.infoTime }}</td>
                  <td class="td-2">{{ item.signNum }}</td>
                  <td class="td-2">{{ item.attendNum }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="right-box" @mouseenter="stopScroll" @mouseleave="startScroll">
            <div class="top-card">
              <img style="position: absolute; bottom: 0; right: 100px" src="@/assets/img/competition/tabletennis.svg" />
              <img style="position: absolute; top: 80px; left: -23.7px" src="@/assets/img/competition/arrowleft.svg" />

              <img style="position: absolute; top: 28px; left: 32px" src="@/assets/img/competition/line1.svg" />
              <img style="position: absolute; top: 28px; right: 32px" src="@/assets/img/competition/line2.svg" />
              <div
                style="
                  padding: 16px 64px;
                  height: 170px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
                class=""
              >
                <div class="d-aligncnter" style="align-items: flex-start">
                  竞赛项目
                  <div :title="raceList[currIndex].event" class="typeName">
                    {{ raceList[currIndex].event }}
                  </div>
                </div>
                <div class="mt-16 d-aligncnter" style="align-items: flex-start">
                  竞赛组别
                  <div :title="raceList[currIndex].infoItemName" class="typeName" style="">
                    {{ raceList[currIndex].infoItemName }}
                  </div>
                </div>
                <div class="mt-16 d-aligncnter">
                  报名时间
                  <span>{{ raceList[currIndex].signUpTime }}</span>
                  <div class="process">
                    <div
                      class="process-curr"
                      :style="{
                        width: raceList[currIndex].signDateRate * 100 + '%',
                      }"
                    ></div>
                  </div>
                </div>
                <div class="mt-16 d-aligncnter">
                  竞赛时间
                  <span>{{ raceList[currIndex].raceTime }}</span>
                  <div class="process">
                    <div
                      class="process-curr"
                      :style="{
                        width: raceList[currIndex].raceDateRate * 100 + '%',
                      }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 学院排名 -->
            <template v-if="raceList.length > 0">
              <div v-if="raceList[currIndex].infoItemList.length > 0">
                <div
                  class="center-card d-aligncnter"
                  style="justify-content: space-evenly"
                  v-if="raceList[currIndex].infoItemList[infoItemListIndex].rankAlive"
                  @mouseenter="stopScroll"
                  @mouseleave="startScroll"
                >
                  <div
                    class="mc-color d-aligncnter"
                    style="width: 800px; margin-top: -16px; position: absolute; top: 28px; left: 32px"
                  >
                    排名：{{ raceList[currIndex].infoName
                    }}<el-select
                      v-model="currTeamType"
                      placeholder="请选择"
                      @change="selectRank"
                      style="width: 220px; margin-left: 16px"
                    >
                      <el-option
                        v-for="(item, index) in raceList[currIndex].infoItemList"
                        :key="item.infoItemId"
                        :label="item.infoItemName"
                        :value="index"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <img style="position: absolute; top: 28px; right: 32px" src="@/assets/img/competition/line3.svg" />
                  <img style="position: absolute; top: 188px; left: 32px" src="@/assets/img/competition/line4.svg" />
                  <div class="d-allcenter d-column" style="width: 200px; height: 288px">
                    <div style="position: relative; width: 278px; height: 176px">
                      <img src="@/assets/img/competition/line.svg" class="mc-line" />
                      <img src="@/assets/img/competition/one.svg" class="mc-one" />
                      <img src="@/assets/img/competition/two.svg" class="mc-two" />
                      <img src="@/assets/img/competition/three.svg" class="mc-three" />
                      <div
                        class="mc-name-one"
                        v-if="raceList[currIndex].infoItemList[infoItemListIndex].rankList.length > 0"
                      >
                        <div>
                          {{ raceList[currIndex].infoItemList[infoItemListIndex].rankList[0].collegeName }}
                        </div>
                        <div>
                          {{ raceList[currIndex].infoItemList[infoItemListIndex].rankList[0].score }}
                        </div>
                      </div>
                      <div
                        class="mc-name-two"
                        v-if="raceList[currIndex].infoItemList[infoItemListIndex].rankList.length > 1"
                      >
                        <div>
                          {{ raceList[currIndex].infoItemList[infoItemListIndex].rankList[1].collegeName }}
                        </div>
                        <div>
                          {{ raceList[currIndex].infoItemList[infoItemListIndex].rankList[1].score }}
                        </div>
                      </div>
                      <div
                        class="mc-name-three"
                        v-if="raceList[currIndex].infoItemList[infoItemListIndex].rankList.length > 2"
                      >
                        <div>
                          {{ raceList[currIndex].infoItemList[infoItemListIndex].rankList[2].collegeName }}
                        </div>
                        <div>
                          {{ raceList[currIndex].infoItemList[infoItemListIndex].rankList[2].score }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-allcenter d-column"
                    style="width: 320px; height: 208px; justify-content: flex-start; flex-wrap: wrap"
                  >
                    <div
                      class="d-aligncnter"
                      style="width: 220px; padding: 6px 0"
                      v-for="(item, index) in raceList[currIndex].infoItemList[infoItemListIndex].rankList"
                      :key="'res_' + index"
                      v-show="index > 2"
                    >
                      <span class="mc-color mc-fs weight">{{ index + 1 }}</span>
                      <span class="ml-16">{{ item.collegeName }} {{ item.score }}分</span>
                    </div>
                  </div>
                </div>
                <!-- 学院报名数量 -->
                <div class="center-card d-column" v-else @mouseenter="stopScroll" @mouseleave="startScroll">
                  <img style="position: absolute; top: 28px; right: 32px" src="@/assets/img/competition/line3.svg" />
                  <img style="position: absolute; top: 188px; left: 32px" src="@/assets/img/competition/line4.svg" />
                  <div style="width: 800px; margin: 0px 48px 0 48px">
                    <div class="mc-color d-aligncnter">
                      报名人数：{{ raceList[currIndex].infoName }}
                      <el-select
                        v-model="currTeamType"
                        placeholder="请选择"
                        @change="selectRank"
                        style="width: 200px; margin-left: 16px"
                      >
                        <el-option
                          v-for="(item, index) in raceList[currIndex].infoItemList"
                          :key="item.infoItemId"
                          :label="item.infoItemName"
                          :value="index"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="d-aligncnter" style="padding: 0 0 0 32px; height: 190px">
                    <div class="d-allcenter d-column line-list fs-big" style="flex-wrap: wrap">
                      <div
                        class="d-aligncnter"
                        style="width: 260px; margin: 4px 0px"
                        v-for="(item, index) in raceList[currIndex].infoItemList[infoItemListIndex].numList"
                        :key="'res_' + index"
                        :class="{ big: index < 3 }"
                      >
                        <span class="mc-color weight" style="width: 42px; text-align: center">{{ index + 1 }}</span
                        ><span class="ml-16">{{ item.collegeName }} {{ item.collegeNum }}人</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="raceList[currIndex].infoItemList.length > 0">
              <div
                class="bottom-card"
                v-show="raceList[currIndex].rankAlive"
                @mouseenter="stopScroll"
                @mouseleave="startScroll"
              >
                <div class="d-aligncnter mt-16" style="margin-left: 32px">
                  <img src="@/assets/img/competition/star.svg" class="title-img" /><span class="ml-8"
                    >学院竞赛积分统计</span
                  >
                </div>
                <div class="echarts">
                  <div id="totalNum" style="width: 900px; margin: 0 auto; height: 340px"></div>
                </div>
              </div>
              <div
                class="bottom-card"
                v-show="!raceList[currIndex].rankAlive"
                @mouseenter="stopScroll"
                @mouseleave="startScroll"
              >
                <div class="d-aligncnter mt-16" style="margin-left: 32px">
                  <img src="@/assets/img/competition/bar.svg" class="title-img" /><span class="ml-8">分院参赛人数</span>
                </div>
                <div class="echarts">
                  <div id="signinNum" style="width: 900px; margin: 0 auto; height: 340px"></div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </my-scale>
    </div>
  </div>
</template>
<script>
import MyScale from './components/MyScale.vue'
import { getRaceRule, getRaceInfo } from '@/api/api-groupCockpit'
export default {
  name: '',
  components: {
    MyScale,
  },
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      option1: {},
      option2: {},
      currIndex: 0,
      timer: null,
      raceList: [{ event: '', infoItemList: [{}], rankAlive: false }],
      seasonList: [],
      currSeason: '',
      currSeasonId: '',
      currRank: '',
      currRankIndex: 0,
      currNum: '',
      currNumIndex: 0,
      infoItemListIndex: 0,
      currTeamType: '',
      changeIndex: true,
      chartOne: '',
      chartTwo: '',
    }
  },
  created() {
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday
  },
  mounted() {
    // this.timer = setInterval(() => {
    //   if (this.currIndex < this.raceList.length - 1) {
    //     this.currIndex++
    //     if (this.currIndex > 8) {
    //       document.getElementById('table-content').scrollTop =
    //         56 * this.currScale * (this.currIndex - 8)
    //     }
    //   } else {
    //     this.currIndex = 0
    //     document.getElementById('table-content').scrollTop = 0
    //   }
    // }, 2000)

    // this.startScroll()
    this.timer = setInterval(() => {
      if (this.raceList.length > 0) {
        if (this.currIndex < this.raceList.length - 1) {
          if (this.changeIndex) {
            this.currIndex++
            setTimeout(() => {
              if (this.raceList[this.currIndex].rankAlive) {
                this.drawMonthData()
              } else {
                this.drawSigninData()
              }
            }, 200)

            console.log('执行定时器：', this.timer)
            if (this.currIndex > 8) {
              if (document.getElementById('table-content').scrollTop < 56 * this.currScale * (this.currIndex - 8)) {
                document.getElementById('table-content').scrollTop = 56 * this.currScale * (this.currIndex - 8)
              }
            }
          }
        } else {
          if (this.changeIndex) {
            this.currIndex = 0
            document.getElementById('table-content').scrollTop = 0
            if (this.raceList[this.currIndex].rankAlive) {
              this.drawMonthData()
            } else {
              this.drawSigninData()
            }
          }
        }
        if (this.raceList[0].infoItemList.length > 0) {
          this.currTeamType = this.raceList[this.currIndex].infoItemList[0].infoItemName
        }
      }

      //   this.currTeamType = this.raceList[this.currIndex].infoItemList[0].infoItemName
    }, 5000)
    setInterval(() => {
      this.getRaceRuleList()
    }, 100000)
    if (this.raceList[this.currIndex].rankAlive) {
      this.drawMonthData()
    } else {
      this.drawSigninData()
    }
    this.getRaceRuleList()
    window.onresize = () => {
      return (() => {
        if (this.raceList[this.currIndex].rankAlive) {
          this.drawMonthData()
        } else {
          this.drawSigninData()
        }
      })()
    }
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    stopScroll() {
      console.log('stopScroll?')
      //   clearInterval(this.timer)
      //   this.timer = null
      this.changeIndex = false
    },
    startScroll() {
      console.log('startScroll?')
      //   clearInterval(this.timer)
      //   this.timer = null

      this.changeIndex = true
      //   this.timer = setInterval(() => {
      //     if (this.currIndex < this.raceList.length - 1) {
      //       this.currIndex++
      //       this.drawMonthData()
      //       console.log('执行定时器：', this.timer)
      //       if (this.currIndex > 8) {
      //         document.getElementById('table-content').scrollTop =
      //           56 * this.currScale * (this.currIndex - 8)
      //       }
      //     } else {
      //       this.currIndex = 0
      //       document.getElementById('table-content').scrollTop = 0
      //     }
      //   }, 10000)
    },
    changeCurrRace(item, index) {
      console.log('item:', item)
      this.currIndex = index
      if (item.infoItemList.length > 0) {
        this.currTeamType = this.raceList[index].infoItemList[0].infoItemName
      }
      console.log('item:', item.infoItemList.length)
      //   this.currTeamType = this.raceList[index].infoItemList[0].infoItemName
      if (this.raceList[this.currIndex].rankAlive) {
        setTimeout(() => {
          this.drawMonthData()
        }, 200)
      } else {
        setTimeout(() => {
          this.drawSigninData()
        }, 200)
      }
    },
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    changeSize(size) {
      console.log('size:', size)
      //   if (Number(size) < 1) {
      this.currScale = size
      //   }
      //   this.mySize = this.mySize / size
      this.mySize = 5.208 / size
      //   var myChart1 = this.$echarts.init(document.getElementById('totalNum'))
    },
    drawMonthData() {
      console.log('drawMonthData:', this.chartOne)
      //   if (this.chartOne != null && this.chartOne != '' && this.chartOne != undefined) {
      //     this.chartOne.dispose() //销毁
      //   }
      //   this.$echarts.dispose(document.getElementById('totalNum'))
      this.chartOne = this.$echarts.init(document.getElementById('totalNum'))
      this.option1 = {
        legend: {
          data: ['积分统计'],
          right: '10%',
          top: '16',
          itemHeight: 8,
          itemWidth: 8,
          textStyle: {
            color: '#ffffff66',
          },
        },
        tooltip: {},
        axisLabel: {
          color: '#ffffff66',
          fontSize: 12,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 30,
            formatter: function (value) {
              if (value.length > 4) {
                return value.slice(0, 3) + '...'
              }
              return value
            },
          },
          data: this.raceList[this.currIndex].collegeList,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          minInterval: 1,
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)',
            },
          },
        },
        series: [
          {
            name: '积分统计',
            type: 'bar',
            stack: 'one',
            data: this.raceList[this.currIndex].scoreList,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB612' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
        ],
      }
      this.chartOne.setOption(this.option1)
    },
    drawSigninData() {
      //   if (this.chartTwo != null && this.chartTwo != '' && this.chartTwo != undefined) {
      //     this.chartTwo.dispose() //销毁
      //   }
      this.chartTwo = this.$echarts.init(document.getElementById('signinNum'))
      this.option2 = {
        legend: {
          data: ['未参数人数', '参赛人数'],
          right: '10%',
          top: '16',
          itemHeight: 8,
          itemWidth: 8,
          textStyle: {
            color: '#ffffff66',
          },
        },
        tooltip: {},
        axisLabel: {
          color: '#ffffff66',
          fontSize: 12,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 30,
            formatter: function (value) {
              if (value.length > 4) {
                return value.slice(0, 3) + '...'
              }
              return value
            },
          },
          data: this.raceList[this.currIndex].collegeList,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          minInterval: 1,
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)',
            },
          },
        },
        series: [
          {
            name: '参赛人数',
            type: 'bar',
            stack: 'two',
            data: this.raceList[this.currIndex].playList,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#32C5FF' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
          {
            name: '未参数人数',
            type: 'bar',
            stack: 'two',
            data: this.raceList[this.currIndex].noPlayList,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#003924' },
                { offset: 1, color: '#003924' },
              ]),
            },
          },
        ],
      }
      this.chartTwo.setOption(this.option2)
    },
    selectRank(e) {
      console.log('selectRank?:', e)
      //   this.selectRank
      this.infoItemListIndex = e
    },
    selectNum(e) {
      console.log('selectNum?:', e)
    },
    selectChange(e) {
      console.log('selectChange?:', this.seasonList)
      console.log('selectChange?:', e)
      this.currSeasonId = e
      this.getRaceInfoList()
    },
    getRaceRuleList() {
      console.log('res???:')
      getRaceRule().then((res) => {
        console.log('res???:', res)
        this.seasonList = res.data.obj
        this.currSeasonId = this.seasonList[0].ruleId
        this.currSeason = this.seasonList[0].year
        this.getRaceInfoList()
      })
    },
    getRaceInfoList() {
      this.timer = null

      console.log(typeof this.currSeasonId)
      getRaceInfo(this.currSeasonId).then((res) => {
        console.log('Res', res)
        if (res.data.statusCode == 1) {
          this.raceList = res.data.obj
          if (this.raceList.length > 0) {
            if (this.raceList[0].infoItemList.length > 0) {
              this.currTeamType = this.raceList[0].infoItemList[0].infoItemName
            }
            if (this.raceList[this.currIndex].rankAlive) {
              this.drawMonthData()
            } else {
              this.drawSigninData()
            }
          }

          //   this.timer = setInterval(() => {
          //     if (this.currIndex < this.raceList.length - 1) {
          //       this.currIndex++
          //     } else {
          //       this.currIndex = 0
          //     }
          //   }, 10000)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/competition.scss';
::-webkit-scrollbar {
  display: none;
}
.sys-temp ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: transparent !important;
}
.sys-temp ::v-deep .el-input__inner {
  border: none !important;
  color: #fff;
  font-size: 0.45rem;
}
.center-card ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: transparent !important;
}
.center-card ::v-deep .el-input__inner {
  border: none !important;
  color: #00ffa1;
  padding: 0px 1px;
  font-size: 16px;
  text-align: center;
}
.big {
  font-size: 22px;
  padding: 12px 0;
}
</style>
